import { TAB_STRING } from "@/constants/tab-report";
export default {
    data() {
        return {
            menuItems: [
                {
                    to: "/schedule",
                    isExtentionEnabled: "",
                    access: "schedule.access",
                    icon: "schedule",
                    label: "Schedule",
                    topMenuId: "schedule",
                    children: [
                        {
                            to: "/schedule/appointment",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Appointments",
                            topMenuId: ""
                        },
                        {
                            to: "/schedule/census",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Census",
                            topMenuId: ""
                        },
                        {
                            to: "/schedule/treatment",
                            isExtentionEnabled: "",
                            access: "schedule.treatmentboard.view",
                            icon: "",
                            label: "Treatment",
                            topMenuId: ""
                        },
                        {
                            to: "/schedule/boarding/dashboard",
                            isExtentionEnabled: "",
                            access: "schedule.boarding.access",
                            icon: "",
                            label: "Boarding",
                            topMenuId: "boarding",
                            children: [
                                {
                                    to: "/schedule/boarding/dashboard",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Dashboard",
                                    topMenuId: ""
                                },
                                {
                                    to: "/schedule/boarding/reservations",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Reservation",
                                    topMenuId: ""
                                }
                            ]
                        },
                        {
                            to: "/report/reminder",
                            isExtentionEnabled: "",
                            access: "schedule.reminder.access",
                            icon: "",
                            label: "Reminders",
                            topMenuId: ""
                        }
                    ]
                },
                {
                    to: "/patient",
                    isExtentionEnabled: "",
                    access: "patient.access",
                    icon: "patients",
                    label: "Patients",
                    topMenuId: "patients",
                    children: [
                        {
                            to: "/patient/dashboard?tab=patients",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "List",
                            topMenuId: ""
                        },
                        {
                            to: "/patient/lab-results",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Labs",
                            topMenuId: ""
                        },
                        {
                            to: "/patient/image-results",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Images",
                            topMenuId: ""
                        },
                        {
                            to: "/patient/dashboard?tab=customdiagnoses",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Diagnoses",
                            topMenuId: ""
                        },
                        {
                            to: "/patient/dashboard?tab=refillrequest",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Rx Request",
                            topMenuId: ""
                        }
                    ]
                },
                {
                    to: "/client",
                    isExtentionEnabled: "",
                    access: "client.access",
                    icon: "clients",
                    label: "Clients",
                    topMenuId: "clients",
                    children: [
                        {
                            to: "/client/dashboard?tab=clients",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "List",
                            topMenuId: ""
                        }
                    ]
                },
                {
                    to: "/contact",
                    isExtentionEnabled: "",
                    access: "contact.access",
                    icon: "contacts",
                    label: "Contacts",
                    topMenuId: "contacts",
                    children: [
                        {
                            to: "/contact/dashboard?tab=contacts",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "List",
                            topMenuId: ""
                        }
                    ]
                },
                {
                    to: "/inventory",
                    isExtentionEnabled: "",
                    access: "inventory.access",
                    icon: "inventory",
                    label: "Inventory",
                    topMenuId: "inventory",
                    children: [
                        {
                            to: "/inventory/dashboard?tab=quick-edit",
                            isExtentionEnabled: "",
                            access: "inventory.quick.view",
                            icon: "",
                            label: "List",
                            topMenuId: ""
                        },
                        {
                            to: "/inventory/dashboard?tab=alerts",
                            isExtentionEnabled: "",
                            access: "inventory.alert.view",
                            icon: "",
                            label: "Alerts",
                            topMenuId: ""
                        },
                        {
                            to: "/inventory/dashboard?tab=categories",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Categories",
                            topMenuId: ""
                        },
                        {
                            to: "/inventory/dashboard?tab=orders",
                            isExtentionEnabled: "",
                            access: "inventory.purchase.order.view",
                            icon: "",
                            label: "Orders",
                            topMenuId: ""
                        },
                        {
                            to: "/inventory/dashboard?tab=receipts",
                            isExtentionEnabled: "",
                            access: "inventory.purchase.order.view.receipt",
                            icon: "",
                            label: "Receipts",
                            topMenuId: ""
                        }
                    ]
                },
                {
                    to: "/billing",
                    isExtentionEnabled: "",
                    access: "billing.access",
                    icon: "billing",
                    label: "Billing",
                    topMenuId: "billing",
                    children: [
                        {
                            to: "/billing/dashboard?tab=invoices",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Invoices",
                            topMenuId: ""
                        },
                        {
                            to: "/billing/dashboard?tab=estimates",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Estimates",
                            topMenuId: ""
                        },
                        {
                            to: "/billing/dashboard?tab=payments",
                            isExtentionEnabled: "",
                            access: "setting.payment.view",
                            icon: "",
                            label: "Payments",
                            topMenuId: ""
                        },
                        {
                            to: "/billing/dashboard?tab=returns",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Returns",
                            topMenuId: ""
                        },
                        {
                            to: "/billing/dashboard?tab=credits",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Credits",
                            topMenuId: ""
                        },
                        {
                            to: "/billing/dashboard?tab=refunds",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Refunds",
                            topMenuId: ""
                        },
                        {
                            to: "/billing/dashboard?tab=write-offs",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Write-offs",
                            topMenuId: ""
                        },
                        {
                            to: "/billing/dashboard?tab=cash",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Cash",
                            topMenuId: ""
                        }
                    ]
                },
                {
                    to: "/report",
                    isExtentionEnabled: "",
                    access: "report.access",
                    icon: "reports",
                    label: "Reports",
                    topMenuId: "reports",
                    children: [
                        {
                            to: `/report/dashboard?tab=${TAB_STRING.SCHEDULE}`,
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Schedule",
                            topMenuId: ""
                        },
                        {
                            to: `/report/dashboard?tab=${TAB_STRING.PATIENTS}`,
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Patients",
                            topMenuId: ""
                        },
                        {
                            to: `/report/dashboard?tab=${TAB_STRING.CLIENTS}`,
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Clients",
                            topMenuId: ""
                        },
                        {
                            to: `/report/dashboard?tab=${TAB_STRING.COMMUNICATIONS}`,
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Communications",
                            topMenuId: ""
                        },
                        {
                            to: `/report/dashboard?tab=${TAB_STRING.CONTACTS}`,
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Contacts",
                            topMenuId: ""
                        },
                        {
                            to: `/report/dashboard?tab=${TAB_STRING.INVENTORY}`,
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Inventory",
                            topMenuId: ""
                        },
                        {
                            to: `/report/dashboard?tab=${TAB_STRING.BILLING}`,
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Billing",
                            topMenuId: ""
                        },
                        {
                            to: `/report/dashboard?tab=${TAB_STRING.STAFF}`,
                            isExtentionEnabled: "",
                            access: "setting.staff.view",
                            icon: "",
                            label: "Staff",
                            topMenuId: ""
                        },
                        {
                            to: `/report/dashboard?tab=${TAB_STRING.WELLNESS_PLAN}`,
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Wellness Plan",
                            topMenuId: ""
                        },
                        {
                            to: `/report/dashboard?tab=${TAB_STRING.CUSTOM}`,
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Custom",
                            topMenuId: ""
                        },
                        {
                            to: `/report/dashboard?tab=${TAB_STRING.SCHEDULED_REPORT}`,
                            isExtentionEnabled: "",
                            access: "report.scheduled_reports.view",
                            icon: "",
                            label: "Scheduled Report",
                            topMenuId: ""
                        }
                    ]
                },
                {
                    to: "/settings-ci",
                    isExtentionEnabled: "",
                    access: "setting.access",
                    icon: "settings",
                    label: "Settings",
                    topMenuId: "settings",
                    children: [
                        {
                            to: "/settings-ci?tab=add-ons",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Add-ons",
                            topMenuId: ""
                        },
                        {
                            to: "/settings-ci?tab=configurations",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Configurations",
                            topMenuId: "configurations",
                            children: [
                                {
                                    to: "/settings-ci?tab=configurations",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "General Config",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/address",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Addresses",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/devices",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Devices",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/appointment-types",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Appointment Types",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/clinic-hours",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Clinic Hours",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/discounts",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Discounts",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/email-defaults",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Email Defaults",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/sms-defaults",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "SMS Defaults",
                                    topMenuId: ""
                                },
                                {
                                    to:
                                        "/settings-ci?tab=configurations&subtab=marketing-campaigns",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Marketing Campaigns",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/payment-types",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Payment Types",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/printers",
                                    isExtentionEnabled: "VETTER_PRINTER",
                                    access: "",
                                    icon: "",
                                    label: "Printers",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/production-credits",
                                    isExtentionEnabled: "",
                                    access: "setting.production.credit.view",
                                    icon: "",
                                    label: "Production Credits",
                                    topMenuId: ""
                                },
                                {
                                    to:
                                        "/settings-ci?tab=configurations&subtab=room",
                                    isExtentionEnabled: "",
                                    access: "schedule.boarding.access",
                                    icon: "",
                                    label: "Rooms",
                                    topMenuId: ""
                                },
                                {
                                    to:
                                        "/settings-ci?tab=configurations&subtab=schedule-columns",
                                    isExtentionEnabled: "",
                                    access: "setting.schedule.column.view",
                                    icon: "",
                                    label: "Schedule Columns",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/taxes",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Taxes",
                                    topMenuId: ""
                                }
                            ]
                        },
                        {
                            to: "/settings-ci?tab=integrations",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Integrations",
                            topMenuId: ""
                        },
                        {
                            to: "/settings/payments",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Payments",
                            topMenuId: ""
                        },
                        {
                            to: "/settings/petcare",
                            isExtentionEnabled: "CODE_CLIENT_MOBILE_APP",
                            access: "",
                            icon: "",
                            label: "PetCare",
                            topMenuId: ""
                        },
                        {
                            to: "/settings/permissions",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Permissions",
                            topMenuId: ""
                        },
                        {
                            to: "/settings/users?status=active&role=",
                            isExtentionEnabled: "",
                            access: "setting.staff.view",
                            icon: "",
                            label: "Staff",
                            topMenuId: ""
                        },
                        {
                            to: "/settings/subscriptions",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Subscriptions",
                            topMenuId: ""
                        },
                        {
                            to: "/settings-ci?tab=templates",
                            isExtentionEnabled: "",
                            access: "",
                            icon: "",
                            label: "Templates",
                            topMenuId: "templates",
                            children: [
                                {
                                    to: "/settings/template/all",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "All Templates",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/template/attachment",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Attachments",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/template/bundle",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Bundles (Invoice)",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/template/bundle-estimate",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Bundles (Estimates)",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/template/custom-field",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Custom Fields",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/template/letter",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Letters",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/template/content-snippet",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Snippets",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/template/purchase-order",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Purchase Orders",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/template/medical-note",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Medical Notes",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/template/form",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Forms",
                                    topMenuId: ""
                                },
                                {
                                    to: "/settings/template/wellness-plan",
                                    isExtentionEnabled: "",
                                    access: "",
                                    icon: "",
                                    label: "Wellness Plans",
                                    topMenuId: ""
                                }
                            ]
                        }
                    ]
                }
            ]
        };
    },
    computed: {
        filteredMenuItems() {
            return this.menuItems.filter(item => this._hasAccess(item.access));
        },
        reportTabScheduleActive() {
            return this.$store.state.reportTabScheduleActive;
        }
    },
    methods: {
        isActive(item) {
            const route = this.$route;
            if (item.to === "/schedule") {
                return (
                    (route.path.includes("schedule") &&
                        route.name !== "report_scheduled_form") ||
                    this.reportTabScheduleActive
                );
            }
            if (item.to === "/billing") {
                return (
                    route.path.includes("billing") ||
                    route.name === "direct-url-billing-invoice-profile" ||
                    route.name === "direct-url-billing-estimate-profile"
                );
            }
            if (item.to === "/report") {
                return (
                    route.path.includes("report") &&
                    !this.reportTabScheduleActive
                );
            }
            if (item.to === "/settings-ci") {
                return (
                    route.path.includes("settings") ||
                    route.name === "settings-ci"
                );
            }
            return route.path.includes(item.to.replace("/", ""));
        }
    }
};
